export const GET_TIRE_BRAND_BEGIN = "GET_TIRE_BRAND_BEGIN"
export const GET_TIRE_BRAND_SUCCESS = "GET_TIRE_BRAND_SUCCESS"